import { Loader } from '@/app/components/Loader/Loader'
import { OnboardingType } from '@/app/const'
import { useNavigate } from '@/app/hooks/useNavigate'
import { OnboardingPage } from '@/app/pages/OnboardingPage/OnboardingPage'
import { useSession } from '@/app/state/session'
import { metrikaGoal } from '@/app/utils/metrika'
import type { FunctionalComponent } from 'preact'
import { useLayoutEffect, useState } from 'preact/hooks'
import { useShallow } from 'zustand/shallow'

export const AuthWrapper: FunctionalComponent<{
  type: OnboardingType
}> = props => {
  const route = useNavigate()
  const sessionReady = useSession(s => s.ready)
  const sessionUser = useSession(useShallow(s => s.user))
  const sessionProfile = useSession(useShallow(s => s.profile))

  const [inProgress, setInProgress] = useState(false)

  useLayoutEffect(() => {
    if (sessionUser) {
      metrikaGoal('authorization')
    }

    if (props.type === OnboardingType.Login && sessionUser?.email) {
      route('~/tools', { replace: true })
    }
  }, [props.type, sessionUser])

  if (!sessionReady) {
    return (
      <Loader.Wrapper>
        <Loader type='synastry' />
      </Loader.Wrapper>
    )
  }

  return (
    <>
      {inProgress
          || !sessionUser
          || !sessionProfile?.birthDate
          || !sessionProfile.userName
          || (props.type === OnboardingType.Login && !sessionUser.email)
        ? (
          <OnboardingPage
            type={props.type}
            onStart={() => {
              setInProgress(true)
            }}
            onSuccess={() => {
              setInProgress(false)
            }}
          />
        )
        : props.children}
    </>
  )
}
